"use client";
import { DividerComponent, PaperComponent } from "@/components";
import ListView from "@/components/ListView";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Navbar from "@/screens/terms-conditions/Navbar";
import {
  Box,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import CustomDivider from "../component/custom-divider-component";

function createData(feature, voucher_counts) {
  return { feature, voucher_counts };
}

const rows = [
  createData("vHealth consultation", "Unlimited"),
  createData("Free Health check-up (31 Tests)", 1),
  createData("Free Physical OPD Consultation", 1),
  createData("IHO Discount Network card", "Yes"),
  createData("No. of members applicable", 1),
  createData("Term", "1 year"),
  createData("Membership Fee (Including GST)", "500/-"),
  createData("Kit Delivery", "Digital"),
];

const reasonsToChoosePlan = [
  `Affordable healthcare at your fingertips.`,
  `Comprehensive coverage tailored to your needs.`,
  `Trusted by thousands for reliable and quality healthcare services.`,
];

const medibuddyCards = [
  {
    icon: IMAGES.doctorIcon,
    label: "Unlimited",
    subLabel: "Doctor Consultation",
  },
  {
    icon: IMAGES.stethoscopeIcon,
    label: "Free Physical OPD",
    subLabel: "Consultation Voucher",
  },
  { icon: IMAGES.labTest, label: "31 Lab Tests", subLabel: "Free Vouchers." },
  {
    icon: IMAGES.walletCard,
    label: "IHO Health Card",
    subLabel: "Save on medicines & checkups",
  },
];

const servicesCovered = [
  { icon: IMAGES.stethoscopeLine, label: "Doctor Consultations" },
  { icon: IMAGES.microscope, label: "Lab Tests" },
  { icon: IMAGES.medicineBottle, label: "Medicines" },
  { icon: IMAGES.empathizeLine, label: "Dental Care" },
];

const MedibuddyHealthSubscriptionPlan = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Navbar />
      <Container maxWidth={"lg"} sx={{ padding: { xs: 2, md: 4 } }}>
        <Grid
          bgcolor={"#FFC700"}
          container
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={"stretch"}
          p={{ xs: 2, md: 4 }}
          borderRadius={"24px"}
          mb={4}
          textAlign={"left"}
          // spacing={2}
        >
          <Grid item md={6} sx={{ pl: 0 }}>
            <Image
              src={IMAGES.mediBuddyLogo}
              alt="medibuddy-logo"
              width={isMobile ? 75 : 125}
            />
            <Typography
              mt={{ xs: 1, md: 2 }}
              fontWeight={500}
              fontSize={{ xs: "24px", md: "44px" }}
              width={{ md: "80%", xs: "100%" }}
              textTransform={"capitalize"}
            >
              Health Subscription Plan
            </Typography>
            <Typography
              fontWeight={{ xs: 350, md: 400 }}
              fontSize={{ xs: "12px", md: "16px" }}
              width={{ md: "80%" }}
              lineHeight={"24px"}
              mt={2}
            >
              Stay on top of your health with Medical Buddy’s Health
              Subscription Plan. Get unlimited doctor consultations, discounted
              lab tests, and 24/7 medical support — all in one place.
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            mt={1}
            md={6}
          >
            {medibuddyCards?.map((card, index) => (
              <Grid key={index} item xs={6} md={6}>
                <Grid
                  container
                  flexDirection={{ xs: "row", md: "column" }}
                  alignItems={{ xs: "center", md: "center" }}
                  justifyContent={{ md: "center" }}
                  columnGap={1}
                  rowGap={1}
                  wrap="nowrap"
                  sx={{
                    bgcolor: { md: "#D99A26" },
                    p: { md: 2 },
                    borderRadius: { sm: "20px" },
                    height: { xs: "100%", md: "185px" },
                    width: "100%",
                    color: "#fff",
                  }}
                >
                  <Grid item>
                    <Image
                      src={card.icon}
                      alt={`icon-${index}`}
                      width={isMobile ? 30 : 40}
                    />
                  </Grid>

                  <Grid item textAlign={{ md: "center", xs: "left" }}>
                    <Typography
                      fontWeight={500}
                      fontSize={{ xs: "12px", md: "16px" }}
                    >
                      {card.label}
                    </Typography>
                    <Typography
                      fontWeight={350}
                      fontSize={{ xs: "10px", md: "14px" }}
                    >
                      {card.subLabel}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            Benefits
          </Typography>
        </CustomDivider>
        <PaperComponent
          noDrop
          paperStyle={{
            backgroundColor: "#F2F7F799",
            border: "1px solid #E5F1F1",
          }}
        >
          <Typography
            color={WEB_COLORS.fadeColor}
            textAlign={"left"}
            fontWeight={{ xs: 500, md: 700 }}
            fontSize={{ xs: "14px", md: "32px" }}
          >
            Why choose this membership?
          </Typography>
          <Box ml={2} mt={2} textAlign={"left"}>
            <ListView
              items={reasonsToChoosePlan}
              style={{
                fontSize: isMobile ? "12px" : "16px",
                fontWeight: 400,
                color: "#3F3F3FCC",
                lineHeight: isMobile ? "150%" : "24px",
              }}
            />
          </Box>
          <DividerComponent sx={{ borderStyle: "dashed", mt: 2 }} />
          <Typography
            mt={{ xs: 1, md: 2 }}
            fontWeight={700}
            fontSize={{ xs: "16px", md: "32px" }}
            color={WEB_COLORS.fadeColor}
            textAlign={"left"}
          >
            Get started today!
          </Typography>
        </PaperComponent>

        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            Membership Benfits
          </Typography>
        </CustomDivider>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ marginTop: 2, marginBottom: 4 }}
        >
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#E5F1F1",
                  "&:last-child td": {
                    borderBottom: "1px solid #F0F0F0 !important",
                  },
                }}
              >
                <TableCell
                  sx={{
                    fontSize: { xs: "8px", md: "20px" },
                    color: WEB_COLORS.darkTeal,
                    border: "1px solid #F0F0F0",
                    borderRight: "1px solid #72727299",
                  }}
                >
                  Feature
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: { xs: "8px", md: "20px" },
                    color: WEB_COLORS.darkTeal,
                    textAlign: "center",
                    border: "1px solid #F0F0F0",
                  }}
                >
                  Voucher Counts
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.benefit}
                  sx={{
                    backgroundColor: "#F2F7F799",
                    "&:last-child td": {
                      borderBottom: "1px solid #F0F0F0 !important",
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: 400,
                      fontSize: { xs: "10px", md: "16px" },
                      color: WEB_COLORS.darkTeal,
                      border: "1px solid #F0F0F0",
                      borderRight: "1px solid #72727299",
                      borderBottom: "1px solid #72727299",
                    }}
                  >
                    {row.feature}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "10px", md: "16px" },
                      color: WEB_COLORS.darkTeal,
                      textAlign: "center",
                      border: "1px solid #F0F0F0",
                      borderRight: "1px solid #72727299",
                      borderBottom: "1px solid #72727299",
                    }}
                  >
                    {row.voucher_counts}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            Services covered
          </Typography>
        </CustomDivider>
        <Stack mb={8}>
          {servicesCovered?.map((service, index) => (
            <Stack key={index} flexDirection={"row"} gap={2}>
              <Image src={service.icon} alt="service-icon" />

              <Typography
                fontWeight={400}
                fontSize={{ xs: "12px", md: "16px" }}
                color={"#3F3F3FCC"}
              >
                {service.label}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Container>
    </>
  );
};

export default MedibuddyHealthSubscriptionPlan;
